import css1 from "../assets/css-1.png";
import css2 from "../assets/css-2.png";
import css3 from "../assets/css-3.png";
import css4 from "../assets/css-4.png";
import css5 from "../assets/css-5.png";
import css6 from "../assets/css-6.png";
import css7 from "../assets/css-7.png";
import css8 from "../assets/css-8.png";
import sass1 from "../assets/sass-1.png";
import sass2 from "../assets/sass-2.png";
import sass3 from "../assets/sass-3.png";
import sass4 from "../assets/sass-4.png";
import sass5 from "../assets/sass-5.png";
import sass6 from "../assets/sass-6.png";
import bootstrap1 from "../assets/bootstrap-1.png";
import bootstrap2 from "../assets/bootstrap-2.png";
import bootstrap3 from "../assets/bootstrap-3.png";
import bootstrap4 from "../assets/bootstrap-4.png";
import bootstrap5 from "../assets/bootstrap-5.png";
import bootstrap6 from "../assets/bootstrap-6.png";
import bootstrap7 from "../assets/bootstrap-7.png";
import bootstrap8 from "../assets/bootstrap-8.png";
import bootstrap9 from "../assets/bootstrap-9.png";
import bootstrap10 from "../assets/bootstrap-10.png";
import tailwind1 from "../assets/tailwind-1.png";
import tailwind2 from "../assets/tailwind-2.jpg";
import tailwind3 from "../assets/tailwind-3.png";
import tailwind4 from "../assets/tailwind-4.png";
import tailwind5 from "../assets/tailwind-5.png";
import tailwind6 from "../assets/tailwind-6.png";
import tailwind7 from "../assets/tailwind-7.png";
import tailwind8 from "../assets/tailwind-8.png";
import tailwind9 from "../assets/tailwind-9.png";
import tailwind10 from "../assets/tailwind-10.png";
import tailwind11 from "../assets/tailwind-11.png";
import tailwind12 from "../assets/tailwind-12.png";
import tailwind13 from "../assets/tailwind-13.png";
import react1 from "../assets/react-1.png";
import react2 from "../assets/react-2.png";
import react3 from "../assets/react-3.png";
import react4 from "../assets/react-4.png";
import react5 from "../assets/react-5.png";
import less1 from "../assets/less-1.png";
import less2 from "../assets/less-2.png";
import less3 from "../assets/less-3.png";
import less4 from "../assets/less-4.png";
import less5 from "../assets/less-5.png";
import less6 from "../assets/less-6.png";

export const projects = {
  CSS: [
    {
      title: "My Gallery",
      description:
        "This is solution to a challenge given by devchallenges.io (legacy). In this project, I worked with HTML and Vanilla CSS to create a responsive page containing images and other content. The images were positioned using CSS Grid.",
      tags: ["#HTML", "#CSS", "#Responsive", "#CSSGrid", "#Flexbox"],
      image: css1,
      imageClasses: "h-full object-cover",
      cardClasses: "sm:gap-0 gap-3",
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges/tree/main/my-gallery",
      demoLink: "https://my-gallery-njh5l8s55-shrutishinde418.vercel.app/",
    },
    {
      title: "Recipe Page",
      description:
        "This is a solution to a devchallenges.io (legacy) challenge. I used HTML and Vanilla CSS to construct a responsive recipe page for this project. The content was positioned using Flexbox. If you have the ingredients or have completed a step, you can tick the box next to it.",
      tags: ["#HTML", "#CSS", "#Responsive", "#Flexbox"],
      image: css2,
      imageClasses: "h-full object-cover",
      cardClasses: "sm:gap-0 gap-3",
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges1/tree/main/recipe-page",
      demoLink: "https://recipe-page-eosin-omega.vercel.app/",
    },
    {
      title: "404 Not Found page",
      description:
        "This is a solution to a devchallenges.io (legacy) challenge. I worked with HTML and Vanilla CSS to construct a 404 Not Found Page for this project. The elements were positioned using CSS Grid and Flexbox.",
      tags: ["#HTML", "#CSS", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: css3,
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
      codeLink: "https://github.com/ShrutiShinde418/404-not-found",
      demoLink: "https://shrutishinde418.github.io/404-not-found/",
    },
    {
      title: "NFT Preview Card Component",
      description:
        "This is my response to a frontendmentor.io challenge. HTML and Vanilla CSS were used to construct an NFT Preview Card Component.",
      tags: ["#HTML", "#CSS", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: css4,
      imageClasses: "h-full object-cover",
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor/tree/main/nft-preview-card-component-main",
      demoLink: "https://frontend-mentor-7rj3nmeqz-shrutishinde418.vercel.app/",
      cardClasses: "gap-8",
    },
    {
      title: "Product Preview Card",
      description:
        "This is my response to a frontendmentor.io challenge. HTML and Vanilla CSS were used to construct a Product Preview Card for a perfume.",
      tags: ["#HTML", "#CSS", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: css5,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor2/tree/main/product-preview-card",
      demoLink: "https://product-preview-card-iota-sage.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Blog Preview Card",
      description:
        "This is my response to a frontendmentor.io challenge. HTML and Vanilla CSS were used to construct a Blog Preview Card. CSS Grid was used to center the card",
      tags: ["#HTML", "#CSS", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: css6,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor6/tree/main/blog-preview-card",
      demoLink: "https://blog-preview-card-pied.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Social Links Profile",
      description:
        "This is my response to a frontendmentor.io challenge. HTML and Vanilla CSS were used to construct a Social Links Profile.",
      tags: ["#HTML", "#CSS", "#Responsive", "#Flexbox"],
      image: css7,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor6/tree/main/social-links-profile-main",
      demoLink: "https://social-links-profile-ivory.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Ping coming soon page",
      description:
        "For this Frontend Mentor challenge, I developed a responsive landing page using HTML, Vanilla CSS, and Vanilla JS. The page features a user-friendly form for email input, with built-in validation to display an error message if the email entered is invalid. Clean, functional, and engaging design underpins this project.",
      tags: ["#HTML", "#CSS", "#Responsive", "#Flexbox", "VanillaJS"],
      image: css8,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor7/tree/main/ping-coming-soon-page",
      demoLink: "https://ping-coming-soon-page-nine-chi.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
  ],
  SASS: [
    {
      title: "Newsletter Popup",
      description:
        "This is my response to a frontendmentor.io challenge. Using SASS, a newsletter popup page was created. The required attribute of the input element was used for form validation.",
      tags: ["#HTML", "#SASS", "#Responsive", "#CSSGrid", "#Flexbox"],
      image: sass1,
      codeLink: "https://github.com/ShrutiShinde418/newsletter-popup",
      demoLink: "https://shrutishinde418.github.io/newsletter-popup",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Huddle Landing Page with Single Introductory Section",
      description:
        "This is a Frontend Mentor solution to the Huddle landing page problem with a single introductory piece. This page was created with SASS, Grid, and Flexbox.",
      tags: ["#HTML", "#SASS", "#Responsive", "#CSSGrid", "#Flexbox"],
      image: sass2,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor1/tree/main/huddle-page",
      demoLink: "https://huddle-page-gray.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "QR Code Component",
      description:
        "This is a solution to Frontend Mentor's QR code component challenge. SASS, Flexbox, and Semantic HTML were used to create the solution.",
      tags: ["#HTML", "#SASS", "#Responsive", "#CSSGrid", "#Flexbox"],
      image: sass3,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor/tree/main/qr-code-component",
      demoLink:
        "https://qr-code-component-9napp7t9v-shrutishinde418.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "3 column preview card component",
      description:
        "This is an SASS-based solution to Frontend Mentor's 3-column preview card component challenge. The user should be able to see the appropriate layout based on the screen size of their device, as well as hover states for interactive components.",
      tags: ["#HTML", "#SASS", "#Responsive", "#CSSGrid", "#Flexbox"],
      image: sass4,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor4/tree/main/3-column-preview-card",
      demoLink: "https://3-column-preview-card-ten-sigma.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Profile Card Component",
      description:
        "This is an SASS Preprocessor-based solution to the Frontend Mentor Profile card component challenge. When it came to placing the backdrop, I utilised position: fixed and the transform attribute to help.",
      tags: ["#HTML", "#SASS", "#Responsive", "#CSSGrid", "#Flexbox"],
      image: sass5,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor4/tree/main/profile-card-component",
      demoLink: "https://profile-card-component-seven-lemon.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Minimal Blog Card",
      description:
        "This is an SASS-based solution to the Minimal Blog Card challenge on DevChallenges.io.",
      tags: ["#HTML", "#SASS", "#Responsive", "#CSSGrid", "#Flexbox"],
      image: sass6,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges2/tree/main/mini-blog-card",
      demoLink: "https://minimal-blog-card-ten.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
  ],
  LESS: [
    {
      title: "Business Blog Card Solution",
      description:
        "The LESS preprocessor was used to create a business blog card in this solution. Devchallenges.io issued the challenge.",
      tags: ["#HTML", "#LESS", "#Flexbox", "#CSSGrid"],
      image: less1,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges2/tree/main/business-blog-card",
      demoLink: "https://business-blog-card-sigma.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Checkout Page",
      description:
        "In this approach, the LESS preprocessor was utilised to develop a Checkout Page. Devchallenges.io (legacy) issued the challenge. During this assignment, I learned how to carry out form validation along with making an counter and calculating the total price of the items and updating it dynamically.",
      tags: ["#HTML", "#LESS", "#Flexbox", "#CSSGrid"],
      image: less2,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges1/tree/main/checkout-page",
      demoLink: "https://checkout-page-green.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Insure Landing Page",
      description:
        "In this challenge, the LESS preprocessor was used to develop a Landing Page. frontendmentor.io issued the challenge. I learned how to construct a hamburger menu using an offcanvas.",
      tags: ["#HTML", "#LESS", "#Flexbox", "#CSSGrid"],
      image: less3,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor5/tree/main/insure-landing-page",
      demoLink: "https://insure-landing-page-five-iota.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Testimonial Page",
      description:
        "In this challenge, the LESS preprocessor was used to develop a Testimonial Page. DevChallenges.io issued the challenge.",
      tags: ["#HTML", "#LESS", "#Flexbox", "#CSSGrid"],
      image: less4,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges3/tree/main/testimonial-page",
      demoLink: "https://testimonial-page-sepia.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Contact Page",
      description:
        "In this challenge, the LESS preprocessor was used to develop a Contact Page. DevChallenges.io issued the challenge.",
      tags: ["#HTML", "#LESS", "#Flexbox", "#CSSGrid"],
      image: less5,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges3/tree/main/contact-page",
      demoLink: "https://contact-page-mauve.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "FAQ Accordion",
      description:
        "In this challenge, the LESS preprocessor was utilized to style an FAQ accordion. The FAQ accordion, a common UI component found on websites, allows users to toggle between questions and their respective answers, providing a compact and organized way to present information. The functionality of the accordion was implemented using Vanilla JavaScript.",
      tags: ["#HTML", "#LESS", "#Flexbox", "#CSSGrid", "#JavaScript"],
      image: less6,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor6/tree/main/faq-accordion-main",
      demoLink: "https://faq-accordion-amber-ten.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
  ],
  Bootstrap: [
    {
      title: "Spense Landing Page",
      description:
        "This is a solution to a codewell.cc challenge. A landing page was created using Bootstrap 5.1. I learnt how to use the order property (used Bootstrap classes) to assign a specific order to certain elements.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox"],
      image: bootstrap1,
      codeLink: "https://github.com/ShrutiShinde418/spense-landing-page",
      demoLink: "https://shrutishinde418.github.io/spense-landing-page/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "IndieBrew Landing Page",
      description:
        "This is a codewell.cc challenge solution. Bootstrap 5.1 was used to develop a landing page and a sign up page. Validation was carried out using the built-in browser validation.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox"],
      image: bootstrap2,
      codeLink: "https://github.com/ShrutiShinde418/IndieBrew/",
      demoLink: "https://shrutishinde418.github.io/IndieBrew/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Hosterr Landing Page",
      description:
        "This is a solution to a codewell.cc challenge. Bootstrap 5.1 was used to create a landing page for Hosterr, a website hosting service. The challenge I encountered was in placing the photograph and its background.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox"],
      image: bootstrap3,
      codeLink: "https://github.com/ShrutiShinde418/hosterr",
      demoLink: "https://shrutishinde418.github.io/hosterr/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Order Summary Component",
      description:
        "This is a solution to Frontend Mentor's Order summary card problem. Flexbox and Bootstrap 5.1 were used to create this page.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox"],
      image: bootstrap4,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor1/tree/main/order-summary-component",
      demoLink: "https://order-summary-component-five-xi.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Stats Preview Card Component",
      description:
        "This is a solution to the Frontend Mentor Stats preview card component challenge. Users should be able to examine the optimal layout based on the screen size of their device. Bootstrap 4.5 and Flexbox were used to create the solution.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox"],
      image: bootstrap5,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor/tree/main/stats-preview-card-component-main",
      demoLink: "https://stats-preview-card-component-main-ruddy.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "News Homepage",
      description:
        "This Frontend Mentor solution for the News homepage problem was created with Bootstrap 5.2.2. Users should be able to see the best interface layout based on the screen size of their device, observe hover and focus states for all interactive items on the page, and toggle the mobile menu.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox"],
      image: bootstrap6,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor3/tree/main/news-homepage",
      demoLink: "https://news-homepage-nine.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Huddle Landing Page with alternating feature blocks",
      description:
        "This is a Bootstrap 5.3.1 solution to the Frontend Mentor Huddle landing page with alternating feature blocks challenge. I had trouble inserting the card near the footer. I implemented the techniques I learnt in the Conquering Responsive Layouts course.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: bootstrap7,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor5/tree/main/huddle-landing-page-alternate-blocks",
      demoLink: "https://huddle-page-alternate-blocks.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "TimeNow Page",
      description:
        "This is a Bootstrap-based solution to codewell.cc's TimeNow Challenge. The solution is made up of two pages: a landing page and a pricing page.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: bootstrap8,
      codeLink:
        "https://github.com/ShrutiShinde418/Codewell/tree/main/time-now",
      demoLink: "https://time-now-landing.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Interior Consultant",
      description:
        "This is a solution for the devchallenges.io (legacy) Interior Consultant Challenge developed with Bootstrap 5.1. During this challenge, I learned how to create an off-canvas menu. ",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: bootstrap9,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges/tree/main/interior-consultant",
      demoLink:
        "https://interior-consultant-hkaf2zt4l-shrutishinde418.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Alarado Page",
      description:
        "This is a solution to the DevChallenges.io Alarado Page Challenge using Bootstrap 5.3.1. Users should be able to do the following: Create a simple homepage page that matches the provided design; the visitor should be able to switch between light and dark modes (light being the default). The page should adapt to multiple screen sizes. Users should be able to toggle side navigation on mobile. I learned how to build a toggle switch and toggle between light and dark modes.",
      tags: ["#HTML", "#Bootstrap", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: bootstrap10,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges2/tree/main/alarado-page",
      demoLink: "https://alarado-page.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
  ],
  Tailwind: [
    {
      title: "Advice Generator App",
      description:
        "This is a response to a frontendmentor.io challenge. An advice generator app was created using Tailwind CSS, HTML, Javascript and an API.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#API"],
      image: tailwind1,
      codeLink: "https://github.com/ShrutiShinde418/advice-generator-app",
      demoLink: "https://advice-generator-app-weld.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Single Price Grid Component",
      description:
        "This is a solution to Frontend Mentor's Single-price grid component challenge. Users should be able to view the best layout for the component based on the device's screen size, as well as a hover state for the Sign Up call-to-action on the desktop. TailwindCSS, Flexbox, and CSS Grid were used to create this solution.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind2,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor1/tree/main/single-price-grid-component",
      demoLink: "https://frontend-mentor1-hazel.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Clipboard Landing Page",
      description:
        "This is a solution to the Frontend Mentor Clipboard landing page challenge made with Tailwind CSS. Users should be able to view the ideal layout for the site based on the screen size of their device, as well as hover states for all interactive items on the page.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind3,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor2/tree/main/clipboard-landing-page",
      demoLink:
        "https://clipboard-landing-page-gewqeby2b-shrutishinde418.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Four Card Feature Card",
      description:
        "This is a solution to Frontend Mentor's Four-card feature section problem. Users should be able to view the ideal layout for the site based on the screen size of their device. Tailwind CSS and CSS Grid were used to construct this solution. The grid-template-areas property was used to position the cards.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind4,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor2/tree/main/four-card-feature-section",
      demoLink: "https://four-card-feature-self.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Social Proof Section",
      description:
        "This is a Tailwind CSS-based solution to the Frontend Mentor's Social proof section challenge.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind5,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor3/tree/main/social-proof-section",
      demoLink:
        "https://social-proof-section-in1dfcsw9-shrutishinde418.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Testimonials Grid Section",
      description:
        "This is a Tailwind CSS solution to the Frontend Mentor Testimonials grid section challenge. Users should be able to view the site's ideal layout based on the screen size of their device.In this assignment, I learned how to use the max-width attribute.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind6,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor3/tree/main/testimonials-grid-section",
      demoLink:
        "https://frontend-mentor3-2hqzha40p-shrutishinde418.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Result Summary Component",
      description:
        "Tailwind CSS was used to create this solution for the Frontend Mentor Results summary component challenge. Users should be able to see the best interface layout based on the size of their device's screen. For all interactive elements on the page, see the hover and focus states. I learned how to use the Fetch API. The data for the results was retrieved from a local JSON file using the Fetch API.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind7,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor4/tree/main/results-summary-component",
      demoLink:
        "https://results-summary-component-hhfx4rvm9-shrutishinde418.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Fylo Landing Page",
      description:
        "This is a Tailwind CSS solution to the Fylo landing page with a two-column layout problem on Frontend Mentor. This assignment taught me how to validate a form using Javascript.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind8,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor5/tree/main/fylo-landing-page",
      demoLink: "https://fylo-landing-page-roan-eight.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Developer Portfolio",
      description:
        "This is a Tailwind CSS-based solution to codewell.cc's Developer Portfolio Challenge. This assignment taught me how to create a hamburger menu.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind9,
      codeLink:
        "https://github.com/ShrutiShinde418/Codewell/tree/main/developer-portfolio",
      demoLink: "https://developer-portfolio-sable.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Gradie Sign Up",
      description:
        "This is a Tailwind CSS-based solution for the Gradie Sign Up Page on codewell.cc.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind10,
      codeLink:
        "https://github.com/ShrutiShinde418/Codewell/tree/main/gradie-signup",
      demoLink: "https://gradie-signup-j6ppgn0hv-shrutishinde418.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "My Team Page",
      description:
        "This is a Tailwind CSS solution to the My Team Page challenge. Devchallenges.io (legacy) issued the challenge.",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind11,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges/tree/main/my-team-page",
      demoLink: "https://my-team-page-seven-mu.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Edie Homepage",
      description:
        "The Tailwind CSS solution to the Edie Homepage challenge is shown here. The challenge was issued by Devchallenges.io (legacy).",
      tags: ["#HTML", "#Tailwind", "#Responsive", "#Flexbox", "#CSSGrid"],
      image: tailwind12,
      codeLink:
        "https://github.com/ShrutiShinde418/DevChallenges1/tree/main/edie-homepage",
      demoLink: "https://edie-homepage-seven.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
    {
      title: "Time Tracking Dashboard",
      description:
        "This Frontend Mentor challenge involves creating a site that adapts seamlessly to different screen sizes, incorporates hover effects for all interactive elements, and allows users to switch between daily, weekly, and monthly stats. The toggling functionality was implemented using Vanilla JS.",
      tags: [
        "#HTML",
        "#Tailwind",
        "#Responsive",
        "#Flexbox",
        "#CSSGrid",
        "VanillaJS",
      ],
      image: tailwind13,
      codeLink:
        "https://github.com/ShrutiShinde418/FrontendMentor7/tree/main/time-tracking-dashboard",
      demoLink: "https://time-tracking-dashboard-seven-beige.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "gap-8",
    },
  ],
  React: [
    {
      title: "Input Component",
      description:
        "A reusable input component was constructed using React in this solution, and several types of input form fields were implemented by giving the necessary class names. Devchallenges.io (legacy) issued this challenge.",
      tags: ["#React", "#JSX", "#SASS", "#Flexbox", "#CSSGrid"],
      image: react1,
      codeLink: "https://github.com/ShrutiShinde418/input-component",
      demoLink: "https://input-component-snowy.vercel.app/",
      imageClasses: "h-full object-cover",
      cardClasses: "sm:gap-0 gap-3",
    },
    {
      title: "Button Component",
      description:
        "In this approach, a reusable button component was built with React, and multiple sorts of buttons were implemented by assigning the appropriate class names. This challenge was offered by Devchallenges.io (legacy).",
      tags: ["#React", "#JSX", "#SASS", "#Flexbox", "#CSSGrid"],
      image: react2,
      codeLink: "https://github.com/ShrutiShinde418/button-component",
      demoLink: "https://button-component-six.vercel.app/",
      imageClasses: "h-full object-cover",
    },
    {
      title: "Quote Generator",
      description:
        "React and Tailwind CSS was used to create this solution. On the app's home page, random quotes were retrieved via an API. More quotes can be viewed. A button is provided to retrieve random quotes repeatedly. In this project, I learned how to use the useContext hook and how to fetch data from an API using the Fetch API. DevChallenges.io (legacy) issued the challenge.",
      tags: ["#React", "#JSX", "#Tailwind", "#Flexbox", "#API"],
      image: react3,
      codeLink: "https://github.com/ShrutiShinde418/button-component",
      demoLink: "https://button-component-six.vercel.app/",
      imageClasses: "h-full object-cover",
    },
    {
      title: "Todo List App",
      description:
        "This ToDo app was created using React with Tailwind CSS. Redux Toolkit was utilized for state management. The app includes three tabs: All, Active, and Completed. The Redux Persist library was used to keep the store in local storage. DevChallenges.io (legacy) issued the challenge.",
      tags: ["#React", "#JSX", "#Tailwind", "#Flexbox", "#CSSGrid"],
      image: react4,
      codeLink: "https://github.com/ShrutiShinde418/todo-devchallenges",
      demoLink: "https://main--todo-devchallenges-solution.netlify.app/",
      imageClasses: "h-full object-cover",
    },
    {
      title: "Windbnb Clone",
      description:
        "This Windbnb clone was created using React and Tailwind CSS. ReduxJS Toolkit was used for state management. This app allows you to search for rooms according to various locations in Finland and the number of people staying.  DevChallenges.io (legacy) issued the challenge.",
      tags: ["#React", "#JSX", "#Tailwind", "#Flexbox", "#CSSGrid"],
      image: react5,
      codeLink: "https://github.com/ShrutiShinde418/windbnb",
      demoLink: "https://windbnb-sable.vercel.app/",
      imageClasses: "h-full object-cover",
    },
  ],
};
